import { FC } from 'react';
import operationTypes from 'constants/operationTypes';

import DividendsOperationTableBody from '../components/DividendsOperation/DividendsOperationTableBody';
import ContributionOperationTableBody from '../components/ContributionOperation/ContributionOperationTableBody';
import ReclassificationOperationTableBody from '../components/ReclassificationOperation/ReclassificationOperationTableBody';
import SplitOperationTableBody from '../components/SplitOperation/SplitOperationTableBody';
import CapitalVariationOperationTableBody from '../components/CapitalVariationOperation/CapitalVariationOperationTableBody';
import SharesTransferOperationTableBody from '../components/SharesTransferOperation/SharesTransferOperationTableBody';

export const operationTableBodyMap: Record<string, FC> = {
  [operationTypes.CONSTITUTION]: CapitalVariationOperationTableBody,
  [operationTypes.CAPITAL_INCREASE]: CapitalVariationOperationTableBody,
  [operationTypes.CAPITAL_DECREASE]: CapitalVariationOperationTableBody,
  [operationTypes.SELL_PARTICIPATION]: SharesTransferOperationTableBody,
  [operationTypes.HERITAGE]: SharesTransferOperationTableBody,
  [operationTypes.DONATION]: SharesTransferOperationTableBody,
  [operationTypes.ENDORSEMENT]: SharesTransferOperationTableBody,
  [operationTypes.TRANSMISSION]: SharesTransferOperationTableBody,
  [operationTypes.RECLASSIFICATION]: ReclassificationOperationTableBody,
  [operationTypes.SPLIT]: SplitOperationTableBody,
  [operationTypes.DIVIDENDS_DISTRIBUTION]: DividendsOperationTableBody,
  [operationTypes.CONTRIBUTION]: ContributionOperationTableBody,
};
